var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"periodSwitch",staticClass:"period-switch"},_vm._l((_vm.options),function(option){return _c('div',{key:option.id,ref:("periodSwitchItem_" + (option.value)),refInFor:true,staticClass:"period-switch__item",class:{
      'is-active':
        (_vm.selectedPeriod ? _vm.selectedPeriod : _vm.selected) === option.value
    },on:{"click":function($event){return _vm.onClickHandler(option, $event)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }